import {
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  RESET_PASSWORD_RELOAD,
} from 'constants/ActionTypes';

export const userResetPassword = email => ({
  type: RESET_PASSWORD,
  payload: email,
});

export const userResetPasswordSuccess = email => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: { success: true, email },
});

export const userResetPasswordError = () => ({
  type: RESET_PASSWORD_ERROR,
});

export const userResetPasswordReload = () => ({
  type: RESET_PASSWORD_RELOAD,
  payload: {
    success: false,
    email: '',
  },
});
